module.exports = __webpack_public_path__ + "static/pagezooms-012385d49c792de744ed0050dd44178c.png";